import React from 'react'
import { useHistory } from 'react-router-dom'

import {
  NameAndDobCollectionFormUI,
  NameAndDobCollectionFormValues,
} from '~/components/screens/NameAndDobCollectionFormUI'
import { SignupType } from './utils'
import { useTenantConfigQuery } from '~/utils/useTenantConfigQuery'
import { secureCache } from '~/utils/secureCache'
import { logEvent } from '~/utils/events'

const AccountNameForm: React.FC = () => {
  const { data: tenantData, isLoading: tenantConfigLoading } = useTenantConfigQuery()
  const history = useHistory()

  const tenantConsentForms = tenantData?.consentForms?.filter(
    consentForm => consentForm.needsSignature,
  )

  // Initialize form with cached values
  const initialValues: NameAndDobCollectionFormValues = {
    firstName: secureCache.get('firstName') || '',
    lastName: secureCache.get('lastName') || '',
    preferredName: secureCache.get('preferredName') || '',
    termsAndConditions: false,
    consentForms: [],
    dob: secureCache.get('dob') || '',
  }

  const handleSubmit = async (values: NameAndDobCollectionFormValues) => {
    // Add consent forms if terms accepted
    const consentForms = values.termsAndConditions ? tenantConsentForms?.map(f => f.id) || [] : []

    logEvent('ACCOUNT_NAME_SCREEN_COMPLETED', {})

    // Cache all form values
    Object.keys(values).forEach(key => {
      const value = values[key as keyof NameAndDobCollectionFormValues]
      if (value !== undefined) {
        secureCache.set(key, String(value))
      }
    })

    // Cache the calculated consent forms array
    secureCache.set('consentForms', JSON.stringify(consentForms))

    const signupType = secureCache.get('signupType') as SignupType
    if (signupType === SignupType.HEALTH_PLAN_PROSPECT) {
      history.push({ pathname: '/signup/create-account' })
    } else {
      history.push({ pathname: '/signup/account' })
    }
  }

  return (
    <NameAndDobCollectionFormUI
      initialValues={initialValues}
      onSubmit={handleSubmit}
      isLoading={tenantConfigLoading}
    />
  )
}

export default AccountNameForm
